/**
 * @file Search.repository.ts
 * @module SearchRepository
 * @description Reaktīvā stāvokļa krātuve meklēšanas rezultātiem (izmanto @ngneat/elf).
 *              Glabā pašreizējo meklēšanas rezultātu masīvu un ielādes stāvokli.
 *              Tiek atjaunināta no meklēšanas joslas un patērēta meklēšanas rezultātu sarakstā.
 */

import { createStore, select, setProp, withProps } from "@ngneat/elf";
import { NominatimObject, SearchResultObject } from "../map/Feature";

/** Search state properties */
export interface SearchStoreProps {
	/** Search results from Nominatim geocoding or backend search */
	data?: NominatimObject[] | SearchResultObject[];
	/** Whether a search request is in progress */
	loading?: boolean;
	/** ID of the currently selected result for detail view */
	details?: string;
}

const searchStore = createStore({ name: "search" }, withProps<SearchStoreProps>({ loading: false }));

/** Returns an observable of the current search state */
export function getSearchStore() {
	return searchStore.pipe(select((state) => state));
}

/** Updates one or more search state properties */
export function updateSearchStore(props: SearchStoreProps) {
	for (const key in props) {
		if (Object.prototype.hasOwnProperty.call(props, key)) {
			searchStore.update(setProp(key as keyof SearchStoreProps, (props as any)[key]));
		}
	}
}
